import { CaseStudy, CaseStudyTemplate, Company } from "../CaseStudy";
import technologies from "../technologies";

import namakaLogo from "../../../../assets/img/clients/namaka-cropped.webp";

export default function NamakaSubseaNAMS() {
    const caseStudy = new CaseStudyTemplate(
        "NAMAKA Subsea: NAMS",
        (
            <div>
                <p>
                    DEV4 continue to work closely with Namaka Subsea to design, build, deliver and support the NAMS cloud-based system as service to their clients for supporting Diving, ROV and Marine equipment across the world.  Some of the largest global subsea organisations subscribe to NAMS to ensure their equipment is compliant with industry regulations.
                </p>

                <p>
                    NAMS is designed to optimise User Experience and integrate with other systems with enhanced with customised API's.
                </p>

                <p>
                    Some of the key features in NAMS are the dynamic menus and layouts which are driven by data.  This gives the management system complete flexibility to work across different industries and compliance regulations.
                </p>
            </div>
        ),
        // Project Showcase Thumbnail
        "https://around.createx.studio/assets/img/portfolio/list/06.png",
        new Company(
            "Namaka Subsea",
            // Company Logo
            namakaLogo
        ),
        "https://www.namakasubsea.com/products/nams",
        [
            technologies.aspNET,
            technologies.netCore,
            technologies.azure,
            technologies.sqlServer,
            technologies.blazor
        ]
    )

    return (
        <CaseStudy caseStudy={caseStudy}></CaseStudy>
    )
}